import { animate, style, transition, trigger } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationPushService } from '@schoolbelle/api/notification-push';
import { Purchase } from '@schoolbelle/api/purchase';
import { LoadingService } from '@schoolbelle/common/loading';
import { get } from 'lodash-es';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { VirtualAccountService } from './virtual-account.service';
export const stateChangeAnimation = trigger('stateChange', [
  transition('ready=>paid', [style({
    background:'#d4edda',
  }), animate('1s ease')])
]);

@Component({
  selector: 'app-virtual-account',
  templateUrl: './virtual-account.component.html',
  styleUrls: ['./virtual-account.component.scss'],
  animations: [stateChangeAnimation],  

})
export class VirtualAccountComponent implements OnInit {
  get now () {
    return Date.now();
  }
  @Input() item:Purchase;
  status:'unready'|'ready'|'paid'|'expired';
  data:any;
  banks:{name:string, code:string}[] = [];
  vbank_code:FormControl
  vbank_due:FormControl
  form:FormGroup
  subscription = new Subscription();
  constructor(
    private vaccount:VirtualAccountService,
    private loading:LoadingService,
    private push:NotificationPushService,
    private cdRef:ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    if (!this.item) return;
    this.vbank_code = new FormControl(null, Validators.required);


    const date = new Date();
    date.setDate(date.getDate() + 4);
    date.setHours(0,0,0,-1);
    this.vbank_due = new FormControl(date.getTime());
    this.form = new FormGroup({vbank_code:this.vbank_code, vbank_due:this.vbank_due});
    this.getVirtualAccount();
    this.getPossibleBanks();
  }
  ngOnDestroy () {
    this.unlisten();
    this.subscription.unsubscribe();
  }
  getPossibleBanks () {
    this.subscription.add(this.vaccount.getPossibleBanks().subscribe(banks=>this.banks = banks));
  }
  createVirtualAccount () {
    const subscription = this.vaccount.createVirtualAccount({...this.form.value, uuid:this.item.uuid}).subscribe(data=>{
      this.data = data;
      this.status = 'ready';
      this.listen();
      this.cdRef.detectChanges();
    }, (e:HttpErrorResponse)=>{
      console.error(e);
    })
    this.loading.open({busy:subscription});
    this.subscription.add(subscription);

  }

  private listen () {
    this.push.start(`purchase|${this.item.uuid}`);
    this.subscription.add(
      this.push.onNotification
      .pipe(
        filter(e=>{
          const purchase_id = get(e, 'data.purchase_id');
          return this.item.purchase_id === purchase_id;
        }),
      )
      .subscribe(e=>{
        this.getVirtualAccount();
      })
    );

  }
  private unlisten () {
    this.push.end(`purchase|${this.item.uuid}`);
  }
  getVirtualAccount () {
    this.subscription.add(this.vaccount.getVirtualAccount({uuid:this.item.uuid})
    .subscribe(data=>{
      this.data = data;
      this.status = 'ready';
      this.listen();
      this.cdRef.detectChanges();


    }, (e:HttpErrorResponse)=>{
      switch(e.status) {
        case 404:
          this.status = 'unready';
          break;
        case 409:
          this.status = 'paid';
          break;
        case 410:
          this.status = 'expired';
          break;
      }
      this.unlisten();
      this.cdRef.detectChanges();
    }));
  }
}
